import { Component, EventEmitter, Input, OnInit, Output, ViewChild, ChangeDetectionStrategy } from '@angular/core'
import { Product, ProductDepot } from 'depoto-core/src/entities'
import { ModalContainerComponent } from '../../_common/modal-container/modal-container.component'

@Component({
  selector: 'modal-existing-positions',
  templateUrl: 'modal-existing-positions.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
// todo tests for all component and function
export class ModalExistingPositionsComponent {
  @ViewChild('modal') public modal: ModalContainerComponent
  @Input() product: Product // todo name
  @Input() depot: number
  @Output() setPosition: EventEmitter<any> = new EventEmitter<any>()

  loading = false
  showOnlyOccupiedPositions = true
  productDepots: Array<ProductDepot | Partial<ProductDepot>>

  public async showChildModal() {
    this.productDepots = (this.product?.productDepots ?? []).filter(
      pD => Number(pD.depot?.id) === Number(this.depot)
    ) as Array<ProductDepot | Partial<ProductDepot>>
    this.productDepots = this.productDepots.filter(pD => pD.quantityStock > 0)

    this.modal.showChildModal()
  }
  public onHideChildModal(): void {
    this.modal?.childModal?.hide()
  }

  shownPositionsChanged() {
    if (this.showOnlyOccupiedPositions) {
      this.productDepots = (this.product?.productDepots ?? []).filter(
        pD => Number(pD.depot?.id) === Number(this.depot)
      ) as Array<ProductDepot | Partial<ProductDepot>>
      this.productDepots = this.productDepots.filter(pD => pD.quantityStock > 0)
    } else {
      this.productDepots = (this.product?.productDepots ?? []).filter(
        pD => Number(pD.depot?.id) === Number(this.depot)
      ) as Array<ProductDepot | Partial<ProductDepot>>
    }
  }

  positionSelected(productDepot: ProductDepot) {
    this.setPosition.emit({
      position1: productDepot.position1,
      position2: productDepot.position2,
      position3: productDepot.position3,
    })
    this.onHideChildModal()
  }
}
